import * as PrismaRequestFilter
    from '../Components/PrismaRequestFiltering/Model/PrismaRequestFilter'
import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'
import {HttpRequest} from '../Data/HttpRequest'
import * as OffsetLimit from '../Data/OffsetLimit'

export function listWithOffers(
    manufacturerId: number,
    filters: PrismaRequestFilter.M[],
    offsetLimit: OffsetLimit.OffsetLimit
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/` +
                `prisma-request-offers-for-list`,
                {
                    ...PrismaRequestFilter.toQueryParameters(filters),
                    ...OffsetLimit.toQueryParameters(offsetLimit),
                },
            ),
        headers: {
            Accept: 'application/json'
        }
    }
}

export function priceUpdate(
    id: number,
    data: { netPrice: number },
): HttpRequest {
    return {
        verb: 'PUT',
        url: `${server}/prisma-request-offers/${id}/price`,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(data),
    }
}

export function declineOffer(
    id: number,
    data: { comment: string },
): HttpRequest {
    return {
        verb: 'PUT',
        url: `${server}/prisma-request-offers/${id}/decline`,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(data),
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PrismaRequestOfferResource.ts